<template>
  <div class="home">
      <div class="banner">
       <div class="header">
          <div class="input-btn">
            <div class="play-input">
              <input v-if="isLogin" class="input-item" v-model="customerId" :placeholder="$i18n.t('user.loginUsername')" />
              <!-- <button v-if="isLogin"  class="submit-btn" @click="userLogin">
                {{$t('user.login')}}
              </button> -->
              <img v-if="language === 'EN' && isLogin" :src="require('@/assets/ok1.png')" class="submit-btn" @click="userLogin"/>
              <img v-if="language !== 'EN' && isLogin" :src="require('@/assets/ok.png')" class="submit-btn" @click="userLogin"/>
              <div v-if="isLogin" class="id-prompt" @click="openPrompt">
                <span>{{$t('user.imgIdPrompt')}}</span>
              </div>
            </div>
            <div v-if="!isLogin"  class="user-info">
                <div class="user-info-top">
                  <div class="user-info-item">{{$t('user.id')}}: {{userInfo.customerId}}</div>
                  <div style='flex: 1;text-align: right; color: #fff200;' @click="chooseServer">【{{serverName}}】</div>
                </div>
                <div class="user-info-bottom">
                  <div class="user-info-item">{{$t('user.name')}}: {{userInfo.name}}</div>
                  <div style='flex:1; text-align: center;'>{{$t('user.level')}}: {{userInfo.level}}</div>
                  <div style='flex: 1;text-align:center; padding-right: 10px; color: #fff200;' @click="cancel">【{{$t('user.logout')}}】</div>
                </div>
            </div>
            <div class="language-select-dropdown" @click="openLanguageList">
                <span class="language-select-label">{{language}}</span>
                <div class="select-dropdown">
                  <div></div>
                </div>
                <div v-if="isShow" class="language-list">
                  <div class="language-item-cn" @click="chooseLanguage('zh-CN')">
                    CHINESE
                  </div>
                  <div class="language-item-en" @click="chooseLanguage('en-US')">
                    ENGLISH
                  </div>
                </div>
            </div>
            <!-- <a-button type="primary" @click="gotoPay" class="buy-btn">
              {{$t('user.purchase')}}
            </a-button> -->
            <div>
              <img v-if="language === 'EN'" :src="require('@/assets/pay1.png')" class="buy-btn" @click="gotoPay"/>
              <img v-if="language !== 'EN'" :src="require('@/assets/pay.png')" class="buy-btn" @click="gotoPay"/>
            </div>
          </div>
        </div>
     </div>
     <div class="content">
       <img :src="require('@/assets/img/banner1.png')" alt="" class="banner-img">
       <div class="active-date">
         <div v-for="item in data" :key="item.productId">
           <div class="active-logo-box">
              <div class="actvie-logo" :class="{'isActive': language === 'CN'}" v-if="item.atvBaseInfo">
                {{language === 'CN' ? item.atvBaseInfo.nameCn : item.atvBaseInfo.nameEn }}
              </div>
              <div class="actvie-logo" :class="{'isActive': language === 'CN'}" v-if="!item.atvBaseInfo">
                  {{$t('user.activeTitle')}}
              </div>
           </div>
           <div class="active-date-deatil" v-if="item.atvBaseInfo">{{$t('user.activeTiem')}}：{{`${item.atvBaseInfo.startTime} - ${item.atvBaseInfo.endTime}`}}</div>
           <div class="table">
              <div class="table-list" v-if="isGetList">
                    <div class="table-item" v-for="(items, index) in item.rewardsArray" :key="index">
                      <div class="table-item-logo">
                        <img :src="items.url" alt="" class="table-item-logo-img">
                      </div>
                      <div class="table-item-name">
                        {{language === 'CN' ? items.nameCn : items.nameEn}}{{items.num}}
                      </div>
                  </div>
              </div>
              <div class="table-list" v-if="!isGetList">
                    <div class="table-item" v-for="(items, index) in tableData" :key="index">
                      <div class="table-item-logo">
                        <img class="table-item-logo-img" :src="require('@/assets/tableLogo.png')" alt="">
                      </div>
                      <div class="table-item-name">
                        {{ items.nameCn}}
                      </div>
                  </div>
              </div>
            </div>
            <!-- <a-button type="primary" class="receive-btn" :class="{'isActive': item.disabled}" :disabled='item.disabled' @click="_getProduct(item)">
                {{$t('user.receive')}}
            </a-button> -->
            <img v-if="language === 'EN'" :src="require('@/assets/receive1.png')" :class="{'isActive': item.disabled}" class="receive-btn"  @click="_getProduct(item)"/>
            <img v-if="language !== 'EN'" :src="require('@/assets/receive.png')" :class="{'isActive': item.disabled}" class="receive-btn"  @click="_getProduct(item)"/>
            <div class="footer" v-if="item.atvBaseInfo">
              <h2 class="title">{{$t('user.rule')}}</h2>
              <div class="active-rule" v-html="language === 'CN' ? item.atvBaseInfo.ruleCn : item.atvBaseInfo.ruleEn">
                <!-- {{language === 'CN' ? item.atvBaseInfo.ruleCn : item.atvBaseInfo.ruleEn }} -->
              </div>
            </div>
         </div>
       </div>
     </div>
      <a-modal v-model="localModal" :centered="true" :afterClose='closeModalAfter' :title="$i18n.t('user.title')" width="24rem"  class="demo-modal">
          <a-form-model :model="form" ref="ruleForm" :rules="rules">
            <a-form-model-item prop="server" >
              <a-select  v-model="form.server"  :placeholder="$i18n.t('user.title')">
                <a-select-option class="option-item" v-for="item in servers" :key="item.id"  :value="item.value">
                  <span style="font-size: 1.25rem;color: #000; font-family: Microsoft YaHei;">{{item.name}}</span>
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model>
        <div slot="footer" class="footer">
          <a-button type="primary" :loading='loading' @click="handleOk">
            {{$t('user.login')}}
          </a-button>
          <a-button type="danger"  @click="closeModal">
            {{$t('user.cancel')}}
          </a-button>
        </div>
      </a-modal>
      <a-modal
        v-model="loadingModal"
        :closable="false"
        :centered="true"
        :footer="null"
        :maskClosable="false"
        class="loading-modal"
        wrapClassName="loading-modal"
        width="24rem"
      >
        <p class="modal-wait">{{ language === 'CN' ? '加載中...' : 'loading...' }}</p>
      </a-modal>
      <a-modal
        v-model="imgIdModal"
        :closable="false"
        :centered="true"
        :footer="null"
        width="24rem"
        :maskClosable="false"
        class="prompt-modal"
        wrapClassName="prompt-modal"
      >
        <div class="content">
          <img v-if="language === 'EN'"  v-lazy="require('@/assets/img/enId.png')" class="icon-img"/>
          <img v-if="language !== 'EN'" v-lazy="require('@/assets/img/cnId.png')" class="icon-img"/>
          <a-button type="primary" style="width: 7rem; padding: 0" @click="imgIdModal = false">
                {{$t('user.login')}}
          </a-button>
        </div>
      </a-modal>
      <a-modal
        v-model="infoModal"
        :centered="true"
        :title="$i18n.t('user.infoTitle')"
        :footer="null"
        :maskClosable="false"
        class="info-modal"
        wrapClassName="loading-modal"
        width="24rem"
      >
          <div class="info">
            <div class="info-item" v-if="isIdinfo">{{$t('user.promptInfo')}}</div>
            <div class="info-item" v-if="!isIdinfo">{{$t('user.errorNoInfo')}}</div>
            <a-button  class="closed-btn" @click="infoModal = false">
                  {{$t('user.login')}}
            </a-button>
          </div>
      </a-modal>
  </div>
</template>

<script>
import { getUserInfo, getServers, getProductList, getProduct } from '@/api/user'
import moment from 'moment'
import { getUrlParam } from '@/common/js/util'

export default {
  name: 'Home',
  data () {
    return {
      isShow: false,
      localModal: false,
      form: {
        server: undefined
      },
      server: '',
      placeholderLogin: 'Please enter your ID first',
      tableData: [
        { path: '', nameCn: '' },
        { path: '', nameCn: '' },
        { path: '', nameCn: '' },
        { path: '', nameCn: '' }
      ],
      isLogin: true,
      customerId: '',
      title: 'Select server',
      rules: {
        server: [
        ]
      },
      isIdinfo: false,
      userInfo: {},
      // 服务大区
      servers: [],
      width: 0,
      data: [{ productI: 0, disabled: true }],
      isGetList: false,
      loading: false,
      language: 'EN',
      loadingModal: false,
      serversEn: [],
      serversCn: [],
      serverName: '',
      imgIdModal: false,
      infoModal: false
    }
  },
  created () {
    if (getUrlParam('uid') && getUrlParam('name')) {
      this.userInfo.customerId = getUrlParam('uid')
      this.customerId = getUrlParam('uid')
      this.userInfo.name = getUrlParam('name')
      this.userInfo.level = getUrlParam('level')
      this.form.server = getUrlParam('server')
      this.server = getUrlParam('server')
    } else if (getUrlParam('uid') && !getUrlParam('name')) {
      this.userInfo.customerId = getUrlParam('uid')
      this.customerId = getUrlParam('uid')
      this.userInfo.level = getUrlParam('level')
      this.form.server = getUrlParam('server')
      this.server = getUrlParam('server')
      // this._getUerInfo()
    }
    if (this.userInfo.name && this.server === '1') {
      localStorage.setItem('languageSet', 'zh-CN')
      this.$i18n.locale = 'zh-CN'
      this.language = 'CN'
      document.title = '力比游戲活動'
      this.rules.server = [{ required: true, message: '選擇大區' }]
    } else {
      localStorage.setItem('languageSet', 'en-US')
      this.$i18n.locale = 'en-US'
      this.language = 'EN'
      this.rules.server = [{ required: true, message: 'Select server' }]
      document.title = 'Libii Game Active'
    }
    this._getServers('chinese')
    this._getServers('english')
  },
  mounted () {
    this.width = window.innerWidth
    window.addEventListener('resize', this.widthParams)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.widthParams)
    })
  },
  methods: {
    widthParams () {
      this.width = window.innerWidth
    },
    // 获取大区
    _getServers (language) {
      this.loadingModal = true
      getServers({ language })
        .then((res) => {
          this.servers = res
          if (language === 'chinese') {
            this.serversCn = res
          } else {
            this.serversEn = res
          }
          this.language === 'EN' ? this.servers = this.serversEn : this.servers = this.serversCn
          if (this.server && this.servers.find(item => item.value === this.server)) {
            const { name } = this.servers.find(item => item.value === this.server)
            this.serverName = name
          }
          if (!getUrlParam('name') && getUrlParam('uid')) {
            this._getUerInfo()
          } else if (getUrlParam('name') && getUrlParam('uid')) {
            this._getProductList()
          } else {
            this.loadingModal = false
          }
        })
    },
    // 打开语言下拉框
    openLanguageList () {
      this.isShow = !this.isShow
    },
    // 选择语言
    chooseLanguage (item) {
      localStorage.setItem('languageSet', item)
      const locale = localStorage.getItem('languageSet') || 'en-US'
      this.$i18n.locale = locale
      this.$i18n.locale === 'zh-CN' ? this.$i18n.locale = 'zh-CN' : this.$i18n.locale = 'en-US'
      this.language = this.$i18n.locale === 'zh-CN' ? 'CN' : 'EN'
      this.language === 'EN' ? this.servers = this.serversEn : this.servers = this.serversCn
      document.title = locale === 'zh-CN' ? '力比游戲活動' : 'Libii Game Active'
      if (locale === 'zh-CN') {
        this.rules.server = [{ required: true, message: '選擇大區' }]
      } else {
        this.rules.server = [{ required: true, message: 'Select server' }]
      }
      if (this.server && this.servers.find(item => item.value === this.server)) {
        const { name } = this.servers.find(item => item.value === this.server)
        this.serverName = name
      }
    },
    _getProductLists () {
      getProductList({ server: this.server, customerId: this.customerId })
        .then((res) => {
          const currentTime = new Date()
          res.forEach((item, index) => {
            if (item.atvBaseInfo.startTime * 1000 < currentTime < item.atvBaseInfo.endTime * 1000 && this.userInfo.statusAtv.find(items => items === item.productId)) {
              res[index].disabled = false
            } else {
              res[index].disabled = true
            }
            res[index].atvBaseInfo.startTime = moment(item.atvBaseInfo.startTime * 1000).format('YYYY-MM-DD')
            res[index].atvBaseInfo.endTime = moment(item.atvBaseInfo.endTime * 1000).format('YYYY-MM-DD')
          })
          if (res.length > 0) {
            this.data = res
            this.isGetList = true
          }
          this.loading = false
          this.loadingModal = false
          this.localModal = false
        })
        .catch(() => {
          this.loading = false
          this.loadingModal = false
          this.infoModal = true
          this.isIdinfo = false
        })
    },
    _getUerInfo () {
      getUserInfo({ customerId: this.customerId, server: this.server })
        .then((res) => {
          this.userInfo = res
          this.isLogin = false
          if (this.server && this.servers.find(item => item.value === this.server)) {
            const { name } = this.servers.find(item => item.value === this.server)
            this.serverName = name
          }
          this._getProductLists()
        })
        .catch(() => {
          this.loading = false
          this.loadingModal = false
          this.infoModal = true
          this.isIdinfo = false
        })
    },
    _getProductList (server) {
      this.loading = true
      const params = { customerId: this.customerId }
      if (server) {
        params.server = server
      } else {
        params.server = this.server
      }
      getUserInfo(params)
        .then((res) => {
          this.userInfo = res
          this.isLogin = false
          this.server = this.form.server
          if (this.server && this.servers.find(item => item.value === this.server)) {
            const { name } = this.servers.find(item => item.value === this.server)
            this.serverName = name
          }
          this._getProductLists()
        })
        .catch(() => {
          this.loading = false
          this.infoModal = true
          this.isIdinfo = false
        })
    },
    // 打开模态框
    chooseServer () {
      this.form.server = this.server
      this.localModal = true
    },
    // 获取奖品列表
    handleOk (e) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this._getProductList(this.form.server)
        }
      })
    },
    // 关闭模态框
    closeModal () {
      this.localModal = false
    },
    //
    closeModalAfter () {
      this.$refs.ruleForm.resetFields()
    },
    // ok弹出模态框
    userLogin () {
      const reg = /^-?[0-9]*(\.[0-9]*)?$/
      if (!this.customerId) {
        // this.$message.warn(this.$t('user.loginUsername'), 1.5)
        return
      } else if (!reg.test(this.customerId)) {
        this.infoModal = true
        this.isIdinfo = true
        return
      }
      this.localModal = true
    },
    cancel () {
      this.isLogin = true
      this.userInfo = {}
      this.data = [{ productId: 0, disabled: true }]
      this.isGetList = false
      // window.location.replace('#/')
      window.location.replace('#/')
      this.customerId = ''
    },
    // 领取奖品
    _getProduct (row) {
      if (!row.atvBaseInfo) {
        return
      }
      getProduct({ server: this.server, customerId: this.customerId, atvId: row.productId })
        .then(() => {
          this._getUerInfo()
        })
    },
    // 跳转页面
    gotoPay () {
      if (!this.userInfo.customerId) {
        window.location.href = `${window.g.payUrl}/#/`
        return
      }
      window.location.href = `${window.g.payUrl}/#/?uid=${this.userInfo.customerId}&server=${this.server}`
    },
    // 打開id提示模態框
    openPrompt () {
      this.imgIdModal = true
    }
  }
}
</script>
<style lang="less">
  .home{
    font-family: Microsoft YaHei;
    width: 100vw;
    height: 100%;
    display: flex;
    flex-direction: column;
    .banner{
      width: 100%;
      position: relative;
      .header{
        width: 100%;
        background-color: #713e94;
        display: flex;
        padding: 0.75rem 0.5rem 0.875rem 2rem;
        justify-content: start;
        align-items: flex-start;
        .input-btn{
          display: flex;
          align-items: center;
          height: 100%;
          width: 100%;
          .play-input{
            display: flex;
            position: relative;
            .id-prompt{
              position: absolute;
              left: 0.2rem;
              color: #fff;
              font-size: 0.8rem;
              top: 3.55rem;
            }
          }
          .user-info{
            flex: 1;
            font-size: 1.25rem;
            .user-info-top{
              display: flex;
              justify-content: start;
              color: #fff;
              margin-bottom: 0.5rem;
              div{
                text-align: start;
              }
            }
            .user-info-bottom{
              margin-top: 0.5rem;
              display: flex;
              justify-content: space-between;
              color: #fff;
            }
          }
          .input-item{
            width: 17rem;
            background:#4c1e6c;
            font-size: 1.25rem;
            border: none;
            padding: 0.525em;
            color: #fff;
            border-radius: 0.8rem 0 0 0.8rem;
            &:focus {
              border: none;
              outline:none
            }
          }
          .buy-btn{
            margin-left: 1rem;
            height: 5rem;
          }
          .submit-btn{
            height: 3.2rem;
            margin-right: 1.5rem;
          }
        }
        .language-select-dropdown{
            margin-left: 1.5rem;
            box-sizing: border-box;
            color: #fff;
            // height: 3rem;
            // width: 4rem;
            padding: 0.663rem;
            display: flex;
            justify-content: space-around;
            align-content: center;
            border-radius: 1rem;
            position: relative;
            background-color: #4a1b6a;
            .language-select-label{
              font-size: 1.25rem;
              display: flex;
              align-items: center;
              margin-right: 5px;
            }
            .select-dropdown{
              display: flex;
              justify-content: center;
              align-items: center;
              div{
                width: 0;
                height: 0;
                border-left: 0.5rem solid transparent;
                border-right: 0.5rem solid transparent;
                border-top: 0.8rem solid #fff;
              }
            }
            .language-list{
              position: absolute;
              top: 3.5rem;
              right: 0;
              display: flex;
              height: 6rem;
              padding: 0 1rem;
              flex-direction: column;
              background: url('~@/assets/select.png') center center no-repeat;
              background-size: 100%;
              font-size: 1.25rem;
              .language-item-cn{
                height: 50%;
                //line-height: 3rem;
                // vertical-align:middle;
                display: flex;
                align-items: center;
              }
              .language-item-en{
                height: 50%;
                //vertical-align:middle;
                display: flex;
                align-items: center;
              }
            }
        }
      }
    }
    .content{
      flex: 1;
      .banner-img{
        height: 22rem;
        width: 100%;
        margin-bottom: 2rem;
      }
      background: #fef5fa;
      background-image:
          radial-gradient(#fff 20%, transparent 0),
          radial-gradient(#fff 20%, transparent 0);
      background-size: 40px 40px;
      background-position: 0 0, 20px 20px;
      display: flex;
      flex-direction: column;
      .active-date{
        .active-logo-box{
          display: flex;
          justify-content: center;
        }
        .actvie-logo{
          display: flex;
          background: url('~@/assets/active.png') center center no-repeat;
          background-size: 100%;
          padding-left: 2rem;
          padding-right: 1.875rem;
          height: 3rem;
          justify-content: center;
          align-items: center;
          vertical-align:middle;
          font-size: 1.875rem;
          color: #fff;
          &.isActive{
            padding-left:  2.063rem;
            padding-right: 2rem;
          }
        }
        .active-date-deatil{
          color: #6b3796;
          font-size: 1.25rem;
          margin-top: 0.938rem;
          text-align: center;
        }
        .table{
          margin-top: 0.688rem;
          height: 20rem;
          display: flex;
          width: 45rem;
          margin-left: 1rem;
          justify-content: center;
          background: url('~@/assets/table.png') center center no-repeat;
          background-size: 100%;
          .table-list{
            background: #fff;
            margin-top: 1.48rem;
            height: 17rem;
            width: 43rem;
            display: flex;
            justify-content: space-between;
            .table-item{
              flex: 1;
              border-right: 2px solid #ffccf4;
              display: flex;
              flex-direction: column;
              &:last-child{
                border-right: none;
              }
              .table-item-logo{
                height: 72%;
                display: flex;
                justify-content: center;
                align-items: center;
              }
              .table-item-name{
                border-top: 2px solid #ffccf4;
                display: flex;
                flex: 1;
                justify-content: center;
                align-items: center;
                color: #6b3796;
                font-size: 1.25rem;
              }
            }
          }
        }
        .receive-btn{
          height:4rem;
          margin-top: 3rem;
          &.isActive{
            -webkit-filter: grayscale(100%);
            -moz-filter: grayscale(100%);
            -ms-filter: grayscale(100%);
            -o-filter: grayscale(100%);
            filter: grayscale(100%);
            filter: gray;
          }
        }
      }
    }
    .footer{
      padding-top: 2rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .title{
        font-size: 1.875rem;
        color: #cf88cb;
      }
      .active-rule{
        width: 95%;
        border-top: 1px solid #cf88cb;
        padding: 0.6rem 10%;
        position: relative;
        color: #cf88cb;
        font-size: 1.25rem;
        text-align: start;
        &::after{ /*:before和:after必带技能，重要性为满5颗星*/
            content:"";
            top: -4px;
            width:7px;
            left: 0;
            border-radius: 50%;
            height:7px;
            background: #cf88cb;
            position:absolute;
        }
        &::before{
            content:"";
            top: -4px;
            width: 7px;
            right: 0;
            border-radius: 50%;
            height: 7px;
            background: #cf88cb;
            position:absolute;
        }
      }
    }
  }
  @media only screen and(min-width: 1200px) {
      .home{
        width: 1200px;
    }
  }
@media only screen and(max-width: 800px) {
  .table-item-logo-img{
     width: 70%;
  }
}
@media only screen and(max-width: 700px) {
  .table-item-logo-img{
     width: 60%;
  }
}
@media only screen and(max-width: 600px) {
  .table-item-logo-img{
     width: 50%;
  }
}
@media screen and(max-width: 500px) {
  .home{
    .table-item-logo-img{
     width: 45%;
  }
  .header{
    padding: 0.75rem 0.5rem 0.875rem 1rem!important;
    .language-select-dropdown{
      margin-left: 0.5rem!important;
    }
    .submit-btn{
      margin-right: 2.5rem!important;
    }
    .buy-btn{
      height: 4.5rem!important;
    }
  }
  }
}
@media only screen and(max-width: 400px) {
  .submit-btn{
    height: 3.5rem!important;
    margin-right: 0rem!important;
  }
  .language-list{
    top: 3.7rem!important;
  }
}
</style>
